import cn from 'classnames';

import ChevronDown from '@/icons/ChevronDown';

import { type NavProps } from './Nav.types';

const Nav: React.FC<NavProps> = ({ currentId, pages, onClick }) => (
  <nav className="nav">
    <ul className="nav__list">
      {pages.map((page, i) => {
        const showDropdown = page.children && page.children.length > 0;

        return (
          <li
            key={i}
            className={cn('nav__list-item', {
              'nav__list-item--active': currentId === page.id,
            })}
          >
            {showDropdown ? (
              <button
                className="nav__list-button"
                type="button"
                data-testid={`Nav__Button--${i + 1}`}
                onClick={() => {
                  // send analytics event
                  if (window.dataLayer) {
                    window.dataLayer.push({
                      event: 'navigation_widget',
                      group: page.title,
                      subgroup: 'null',
                    });
                  }

                  if (showDropdown) {
                    onClick(page.id);
                  } else {
                    window.location.href = page.url;
                  }
                }}
              >
                {page.title}

                {showDropdown && <ChevronDown width={11} fill="currentColor" />}
              </button>
            ) : (
              <a
                href={page.url}
                className="nav__list-link"
                target={page.isNewWindow && '_blank'}
              >
                {page.title}
              </a>
            )}
          </li>
        );
      })}
    </ul>
  </nav>
);

export default Nav;
